import { useStore } from 'vuex';
import constants from '@/utilities/constants';
import { setRootStyle, convertStyleToNumber, getDefaultSidebarWidth } from '@/utilities/rootStyles';
import EventBus from '@/utilities/eventBus';
import { browserStorageSetItem, browserStorageGetItem } from '@/utilities/browser-storage.util';

export default function useToggleSidebar() {
  const store = useStore();

  const closeSidebar = (breakpoint?: number | null) => {
    if (breakpoint && window.screen.width >= breakpoint) return;

    store.dispatch('setSidebarExpanded', false);

    setRootStyle(constants.sidebarWidthRoot, '0px');
    browserStorageSetItem('sidebarWidth', 0);

    EventBus.$emit('toggledSidebar', false);
  };

  const expandSidebar = () => {
    store.dispatch('setSidebarExpanded', true);

    const width =
      browserStorageGetItem<number>('sidebarExpandWidth') ||
      convertStyleToNumber(getDefaultSidebarWidth());
    setRootStyle(constants.sidebarWidthRoot, `${width}px`);
    browserStorageSetItem('sidebarWidth', width);

    EventBus.$emit('toggledSidebar', true);
  };

  return {
    closeSidebar,
    expandSidebar,
  };
}
